"use client";

import React, { useEffect, useState } from "react";
import "./finder.css";

import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { IoCashOutline } from "react-icons/io5";
import { LuUtensilsCrossed } from "react-icons/lu";
import { GiCoffeeCup } from "react-icons/gi";
import Autocomplete, { createFilterOptions } from "@mui/joy/Autocomplete";
import AutocompleteOption from "@mui/joy/AutocompleteOption";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Add from "@mui/icons-material/Add";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { keywordRes, craveProvincesRes, restaurantsRes } from "./data.js";
import { Pagination } from "@mui/material";

const ALL_PROVINCES = "ALL PROVINCES";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const filter = createFilterOptions();

const ResturantFinder = () => {
  const [provinces, setProvinces] = useState([]);
  const [province, setProvince] = useState(ALL_PROVINCES);
  const [page, setPage] = useState(1);
  const [restaurants, setRestaurants] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [totalResults, setTotalResults] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [discountType, setDiscountType] = useState(1);

  const isAllProvinces = province === ALL_PROVINCES;
  const provinceQuery = isAllProvinces ? "" : province;

  const handleChange = (event) => {
    setProvince(event.target.value);
    setPage(1);
    setIsFetching(true);
  };

  const [value, setValue] = React.useState(null);

  useEffect(() => {
    craveProvincesRes
      .then((res) => {
        if (res?.Data) {
          setProvinces(res.Data);
        }
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    restaurantsRes(provinceQuery, discountType, page)
      .then((res) => {
        if (res?.Data?.Establishments) {
          setRestaurants(res.Data.Establishments);
          setTotalResults(res.Data.Count);
          setIsFetching(false);
          retrieveKeyword();
        }
      })
      .catch((error) => {
        setIsFetching(false);
      });
  }, [province, discountType, page]);

  const retrieveKeyword = () => {
    if (keyword === "" || !keyword) return;

    keywordRes(keyword, discountType, page)
      .then((res) => {
        if (res?.Data?.Establishments) {
          const establishments = isAllProvinces
            ? res.Data.Establishments
            : res.Data.Establishments.filter(
                (restaurant) => restaurant.Region === province
              );

          setRestaurants(establishments);
          setTotalResults(establishments.length);
          setIsFetching(false);
        }
      })
      .catch((error) => {
        setIsFetching(false);
      });
  };

  useEffect(() => {
    retrieveKeyword();
  }, [keyword, discountType, page, province]);

  return (
    <div className="main-page-container">
      {/* search filter start */}
      <div className="filter-wrapper">
        <div className="filter">
          <div>
            <h4
              className="search-title"
              style={{ textAlign: "center", color: "#1976d2" }}
            >
              REFINE YOUR SEARCH
            </h4>
          </div>

          <hr className="solid" />

          <div className="province-dropdown">
            <h4 className="search-title">PROVINCES</h4>

            <Box className="dropdown" sx={{ minWidth: 120 }}>
              <FormControl className="control" fullWidth>
                <Select
                  sx={{ ".MuiOutlinedInput-notchedOutline": { border: 0 } }}
                  value={province}
                  onChange={handleChange}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  style={{ padding: "-10px" }}
                >
                  <MenuItem value={ALL_PROVINCES}>{ALL_PROVINCES}</MenuItem>
                  {provinces.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <hr className="solid" />

            <div className="discount-type">
              <h4 className="search-title">DISCOUNT TYPE AVAILABLE</h4>

              <div className="radio-parent">
                <div className="search-title child-1">
                  <IoCashOutline /> CASHBACK DINING
                  <br />
                  {/* <br />
                  <LuUtensilsCrossed /> ZAPPER DINING
                  <br />
                  <br />
                  <GiCoffeeCup /> ZAPPER COFFEE
                  <br /> */}
                </div>

                <div className="child-2">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="CASHBACK-DINING"
                      name="radio-buttons-group"
                      value={discountType}
                    >
                      <FormControlLabel
                        value="CASHBACK-DINING"
                        control={
                          <Radio
                            value={1}
                            onChange={(e) => {
                              setDiscountType(1);
                              setPage(1);
                              setIsFetching(true);
                            }}
                          />
                        }
                      />
                      {/* <FormControlLabel
                        value="ZAPPER-DINING"
                        control={
                          <Radio
                            value={2}
                            onChange={(e) => {
                              setDiscountType(2);
                            }}
                          />
                        }
                      />
                      <FormControlLabel
                        value="ZAPPER-COFFEE"
                        control={
                          <Radio
                            value={3}
                            onChange={(e) => {
                              setDiscountType(3);
                            }}
                          />
                        }
                      /> */}
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>

              <hr className="solid" />

              <div className="keyword-search">
                <h4 className="search-title" style={{ marginBottom: "10px" }}>
                  KEYWORD
                </h4>

                <FormControl id="free-solo-with-text-demo" fullWidth>
                  <Autocomplete
                    placeholder="ENTER KEYWORD"
                    value={value}
                    onChange={(event, newValue) => {
                      setPage(1);
                      setIsFetching(true);
                      if (typeof newValue === "string") {
                        setValue({
                          title: newValue,
                        });

                        setKeyword(newValue);
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValue({
                          title: newValue.inputValue,
                        });

                        setKeyword(newValue.inputValue);
                      } else {
                        setValue(newValue);
                        setKeyword(newValue);
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                        (option) => inputValue === option.title
                      );
                      if (inputValue !== "" && !isExisting) {
                        filtered.push({
                          inputValue,
                          title: `Add "${inputValue}"`,
                        });
                      }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    freeSolo
                    options={[]}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.title;
                    }}
                    renderOption={(props, option) => (
                      <AutocompleteOption {...props}>
                        {option.title?.startsWith('Add "') && (
                          <ListItemDecorator>
                            <Add />
                          </ListItemDecorator>
                        )}

                        {option.title}
                      </AutocompleteOption>
                    )}
                    sx={{ width: "100%" }}
                  />
                </FormControl>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* search filter end */}

      <div className="results">
        {!isFetching ? (
          restaurants.length > 0 ? (
            restaurants.map((restaurant, index) => (
              <React.Fragment key={index}>
                <div key={index} className="resturant-result">
                  {/* Restaurant result start */}
                  <div className="resturant-result-child-1">
                    <img src={restaurant.Image} alt="" />
                  </div>

                  <div className="resturant-result-child-2">
                    {/* Restaurant details */}
                    <div className="resturant-details">
                      <div className="resturant-details-1">
                        <h3 style={{ color: "#3FAE49" }}>{restaurant.Name}</h3>
                        <h4 style={{ color: "grey" }}>
                          {`${restaurant.AddressLine1}, ${restaurant.Region}`}
                        </h4>
                        <div style={{ color: "darkgrey" }} className="deatils">
                          <div className="deatils-1">
                            <div className="d1-item1">
                              {/* <h5>TRADING HOURS</h5>
                              <div className="trading-hours-container">
                                {restaurant.Monday === "Yes" && (
                                  <div>
                                    <span>Monday:</span> {restaurant.OpenMonday}
                                    - {restaurant.CloseMonday}
                                  </div>
                                )}
                                {restaurant.Tuesday === "Yes" && (
                                  <div>
                                    <span>Tuesday:</span>{" "}
                                    {restaurant.OpenTuesday}-{" "}
                                    {restaurant.CloseTuesday}
                                  </div>
                                )}
                                {restaurant.Wednesday === "Yes" && (
                                  <div>
                                    <span>Wednesday:</span>{" "}
                                    {restaurant.OpenWednesday}-{" "}
                                    {restaurant.CloseWednesday}
                                  </div>
                                )}
                                {restaurant.Thursday === "Yes" && (
                                  <div>
                                    <span>Thursday:</span>{" "}
                                    {restaurant.OpenThursday}-{" "}
                                    {restaurant.CloseThursday}
                                  </div>
                                )}
                                {restaurant.Friday === "Yes" && (
                                  <div>
                                    <span>Friday:</span> {restaurant.OpenFriday}
                                    - {restaurant.CloseFriday}
                                  </div>
                                )}
                                {restaurant.Saturday === "Yes" && (
                                  <div>
                                    <span>Saturday:</span>{" "}
                                    {restaurant.OpenSaturday}-{" "}
                                    {restaurant.CloseSaturday}
                                  </div>
                                )}
                                {restaurant.Sunday === "Yes" && (
                                  <div>
                                    <span>Sunday:</span> {restaurant.OpenSunday}
                                    - {restaurant.CloseSunday}
                                  </div>
                                )}
                              </div> */}
                              <h5>CONTACT NUMBER</h5>
                              {restaurant.TelephoneNumber}
                            </div>
                            <div className="d1-item2">
                              {/* <h5>AMBIENCE</h5>
                              {restaurant.Ambience}
                              <br />
                              <br />
                              <br /> */}
                              <h5>FOOD TYPE</h5>
                              {restaurant.Cuisine}
                            </div>
                          </div>
                          <a
                            className="button-map"
                            href={`https://www.google.com/maps/@${restaurant.Latitude},${restaurant.Longitude},15z`}
                          >
                            <button className="btn map-but">MAP</button>
                          </a>
                        </div>
                      </div>
                    </div>
                    {/* Restaurant details end */}
                  </div>
                  {/* Restaurant result end */}
                </div>
                <hr className="listing-divider" />
              </React.Fragment>
            ))
          ) : (
            <div className="fetching-container">No Restaurants Found.</div>
          )
        ) : (
          <div className="fetching-container">Fetching Restaurants...</div>
        )}

        <Pagination
          count={Math.ceil(totalResults / 10)}
          variant="outlined"
          shape="rounded"
          onChange={(event, value) => {
            setPage(value);
            setIsFetching(true);
          }}
        />
      </div>

      {/* Restaurant search results end */}
    </div>
  );
};

export default ResturantFinder;
